// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"13":"component---src-pages-logo-design-js","293":"component---src-pages-index-js","776":"component---src-pages-entropy-js"}[chunkId] || chunkId) + "-" + {"13":"a828212032c5d022be37","293":"1bf6333589c2bcc7b8b4","454":"8bcbc22c2d6aef25cdf1","776":"44b7de0e1b0c20bff5a6"}[chunkId] + ".js";
};